import React, { useRef } from 'react';

const MIN_WIDTH = 60;

const HANDLE_STYLE = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  width: 8,
  cursor: 'col-resize',
  userSelect: 'none',
};

const ResizeHandle = ({ width, onResize }) => {
  const drag = useRef(null);

  const onPointerMove = event => {
    if (!drag.current) { return; }

    const moved = event.clientX - drag.current.startX;

    drag.current.width = Math.max(MIN_WIDTH, drag.current.startWidth + moved);
  };

  const stopDragging = () => {
    window.removeEventListener('pointermove', onPointerMove);
    window.removeEventListener('pointerup', stopDragging);

    if (drag.current) {
      onResize(Math.round(drag.current.width));
      drag.current = null;
    }
  };

  const startDragging = event => {
    // The <th> sorts on click; a resize drag must not also re-sort the table.
    event.stopPropagation();
    event.preventDefault();

    const startWidth = width ||
      event.target.parentNode?.getBoundingClientRect?.().width || MIN_WIDTH;

    drag.current = { startX: event.clientX, startWidth, width: startWidth };

    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', stopDragging);
  };

  return (
    <span
      role="separator"
      aria-orientation="vertical"
      style={HANDLE_STYLE}
      onPointerDown={startDragging}
      onClick={event => event.stopPropagation()}
    />
  );
};

export default ResizeHandle;
